import {
  getAccountStore,
  getDeviceAndUserStore,
  getPlatformInfoStore,
} from './storage/stores';
import { getChromeRuntime, getNavigatorUserAgent } from './chrome/wrappers';
import { getTenantName } from './constants';
import { UAParser } from 'ua-parser-js';
import { getAppVersion } from './constants/globals';

// Chrome OS value as returned by chrome.runtime.getPlatformInfo's PlatformOs
const CHROME_OS_PLATFORM_NAME = 'cros';

export const savePlatformInfoIfNeeded = () => {
  if (getPlatformInfoStore().get() === undefined) {
    return new Promise<void>(resolve => {
      getChromeRuntime().getPlatformInfo(platformInfo => {
        getPlatformInfoStore().set({
          arch: platformInfo.arch,
          os: platformInfo.os,
        });
        resolve();
      });
    });
  }
  return Promise.resolve();
};

export const getIdentificationHeader = () => {
  return {
    'Qustodio-Client': `QustodioKidsApp-Chromebook/${getAppVersion()} (${getIdentificationDetails()})`,
  };
};

const getIdentificationDetails = () => {
  const details: string[] = [];

  // Platform
  const platform = getPlatform();
  if (platform) {
    details.push(`p:${platform}`);
  }

  // ChromeOS Version
  const chromeOSVersion = getChromeOSVersion();
  if (chromeOSVersion) {
    details.push(`v:${chromeOSVersion}`);
  }

  // Chrome Version
  const chromeVersion = getUserAgent()?.browser?.version;
  if (chromeVersion) {
    details.push(`bros:${chromeVersion}`);
  }

  // Arch
  const arch = getPlatformInfoStore().get()?.arch;
  if (arch) {
    details.push(`a:${arch}`);
  }

  // DeviceUID
  const deviceUid = getDeviceAndUserStore().get()?.device;
  if (deviceUid) {
    details.push(`duid:${deviceUid}`);
  }

  // AccountUID
  const accountUid = getAccountStore().get()?.accountUid;
  if (accountUid) {
    details.push(`auid:${accountUid}`);
  }

  // Tenant
  details.push(`te:${getTenantName()}`);

  // Store
  details.push(`store:chromestore`);

  return details.join(' ');
};

const getPlatform = () => {
  const os = getPlatformInfoStore().get()?.os;
  if (!os) {
    return undefined;
  }
  return isChromeOS() ? 'chromebook' : 'browser';
};

export const getOSVersion = () => getUserAgent()?.os?.version;

const getChromeOSVersion = () => (isChromeOS() ? getOSVersion() : undefined);

const isChromeOS = () =>
  getPlatformInfoStore().get()?.os === CHROME_OS_PLATFORM_NAME;

const getUserAgent = () => {
  const userAgent = getNavigatorUserAgent();
  return userAgent ? new UAParser(userAgent)?.getResult() : undefined;
};
